import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a755991"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-details-content" }
const _hoisted_2 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"space-between","margin-left":"30px"}
}
const _hoisted_3 = { class: "welcome-title-consultant-project-details" }
const _hoisted_4 = { class: "back-to-all-clients" }
const _hoisted_5 = { class: "project-details-block" }
const _hoisted_6 = { style: {"position":"relative","width":"100%","height":"100%"} }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { style: {"position":"absolute","inset":"110px 0px 100px","min-width":"calc(100% - 110px)","border-radius":"10px","right":"40px"} }
const _hoisted_9 = { style: {"position":"relative","width":"100%","height":"100%"} }
const _hoisted_10 = { style: {"float":"left","width":"500px"} }
const _hoisted_11 = { class: "grid grid-cols-2 gap-4 text-start ml-20" }
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Questionnaire Name", -1))
const _hoisted_14 = { class: "col-span-1" }
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "col-span-1" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Description", -1))
const _hoisted_20 = { class: "col-span-2 flex justify-between" }
const _hoisted_21 = { class: "flex gap-3 items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Active", -1))
const _hoisted_23 = { class: "input-project-active" }
const _hoisted_24 = {
  key: 0,
  class: "error-mess"
}
const _hoisted_25 = {
  key: 0,
  style: {"float":"left","width":"calc(100% - 500px)","padding-left":"100px"}
}
const _hoisted_26 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"space-between","margin-bottom":"24px"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","text-align":"left"} }, "Respondents", -1))
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = {
  key: 0,
  style: {"display":"inline-block","line-height":"24px","height":"40px"}
}
const _hoisted_31 = {
  key: 1,
  style: {"display":"inline-block","padding-right":"30px","line-height":"25px","height":"40px"}
}
const _hoisted_32 = {
  key: 2,
  style: {"display":"inline-block","line-height":"40px","height":"40px"}
}
const _hoisted_33 = {
  key: 3,
  style: {"display":"inline-block","line-height":"40px","height":"40px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IciButton = _resolveComponent("IciButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_IciStatus = _resolveComponent("IciStatus")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$route.path.includes('/new') ? 'Add' : 'Edit') + " Questionnaire", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_IciButton, {
          id: "backToDashboard",
          content: _ctx.constructLabel(_ctx.buttonBackToDashboard, _ctx.$t('companyForm.buttonBackToDashboard')),
          onButtonClick: _ctx.gotoClientDashboard,
          btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important; top: 32px; position: static;"
        }, null, 8, ["content", "onButtonClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          style: {"position":"absolute","top":"40px","left":"40px","right":"40px","height":"50px","border-radius":"10px","background-color":"#fbfaff","font-family":"'Public Sans'","font-weight":"bold","text-align":"left","padding-left":"40px","line-height":"50px"},
          innerHTML: _ctx.$route.path.includes('/new') ? 'Add Questionnaire' : 'Edit Questionnaire'
        }, null, 8, _hoisted_7),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.questionnaire.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.questionnaire.name) = $event)),
                    class: "field-project-name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$tc('companyForm.fieldLabelYear')), 1),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.questionnaire.year,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.questionnaire.year) = $event)),
                    class: "field-project-year"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$tc('companyForm.tableHeaderQuestionnaireDeadline')), 1),
                  _createVNode(_component_Calendar, {
                    modelValue: _ctx.questionnaire.deadline,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.questionnaire.deadline) = $event)),
                    dateFormat: "dd/mm/yy",
                    class: "field-project-deadline"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_Textarea, {
                    class: "w-full",
                    modelValue: _ctx.questionnaire.description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.questionnaire.description) = $event)),
                    autoResize: true
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        class: "check-box-inside",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.questionnaire.active) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.questionnaire.active]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_IciButton, {
                      id: "saveClient",
                      content: _ctx.constructLabel(_ctx.buttonSaveContent, _ctx.$t('profileForm.submit')),
                      onButtonClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save())),
                      btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important;",
                      dark: false
                    }, null, 8, ["content"])
                  ])
                ]),
                (_ctx.errorState)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_Message, { severity: "warn" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.questionnaire.id != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", null, [
                      (_ctx.questionnaire.status != _ctx.QuestionnaireState.CLOSED)
                        ? (_openBlock(), _createBlock(_component_IciButton, {
                            key: 0,
                            id: "addRespondent",
                            content: 'Add Respondent',
                            onButtonClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addRespondent())),
                            btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important;",
                            disabled: _ctx.addRespondentMode,
                            dark: false
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_DataTable, {
                    value: _ctx.questionnaire.respondents,
                    stripedRows: "",
                    selectionMode: "single",
                    scrollHeight: "420px",
                    tableStyle: "width: 100%;"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "id",
                        header: "ID"
                      }, {
                        body: _withCtx((slotProps) => [
                          (slotProps.data.id != 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                innerHTML: slotProps.data.id
                              }, null, 8, _hoisted_28))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "email",
                        header: "Respondent Email"
                      }, {
                        body: _withCtx((slotProps) => [
                          (slotProps.data.id == 0)
                            ? (_openBlock(), _createBlock(_component_InputText, {
                                key: 0,
                                type: "text",
                                modelValue: slotProps.data.email,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.email) = $event),
                                class: "field-project-year",
                                placeholder: "Email"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                innerHTML: slotProps.data.email
                              }, null, 8, _hoisted_29))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "state",
                        header: "State"
                      }, {
                        body: _withCtx((slotProps) => [
                          (slotProps.data.state.id == 0 && _ctx.questionnaire.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createVNode(_component_Checkbox, {
                                  modelValue: slotProps.data.sentInvitation,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.sentInvitation) = $event),
                                  binary: true
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          (slotProps.data.state.id == 0 && _ctx.questionnaire.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, "sent invite "))
                            : _createCommentVNode("", true),
                          (slotProps.data.state.id == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createVNode(_component_IciButton, {
                                  id: "saveRespondent",
                                  content: 'Save',
                                  onButtonClick: ($event: any) => (_ctx.saveRespondent(slotProps.data)),
                                  btnStyle: "width: 80px;",
                                  dark: false
                                }, null, 8, ["onButtonClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (slotProps.data.state.id == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createVNode(_component_IciButton, {
                                  id: "sentInvitation",
                                  content: _ctx.buttonInviteContent,
                                  onButtonClick: ($event: any) => (_ctx.sentInvitationToRespondent(slotProps.data)),
                                  btnStyle: "width: 100px; height: 30px; border-radius: 15px;",
                                  dark: false
                                }, null, 8, ["content", "onButtonClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (slotProps.data.state.id != 1 && slotProps.data.state.id != 0)
                            ? (_openBlock(), _createBlock(_component_IciStatus, {
                                key: 4,
                                state: slotProps.data.state.id
                              }, null, 8, ["state"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}